export const KVKK_TEXT = `KİŞİSEL VERİLERİN KORUNMASI (KVKK) AYDINLATMA METNİ

Veri Sorumlusu: Dijital Roket
İletişim: info@dijitalroket.com

1. Amaç
Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, Dijital Roket marka portalına ("Portal") kayıt olan firma yetkililerinin kişisel verilerinin işlenmesine ilişkin olarak veri sorumlusu sıfatıyla sizleri bilgilendirmek amacıyla hazırlanmıştır.

2. İşlenen Kişisel Veriler
Portal'a kayıt ve hizmetlerin sunulması kapsamında; ad-soyad, telefon numarası, e-posta adresi, firma/marka adı ve tarafınızca girilen firma bilgileri (web sitesi, sosyal medya hesapları, firma tanıtım metni vb.) işlenebilir.

3. Kişisel Verilerin İşlenme Amaçları
- Portal üyelik kaydının oluşturulması ve hesabın onaylanması,
- Hizmetin sunulması ve yapay zekâ ile görsel üretim özelliklerinin sağlanması,
- Hesabınızın onaylanması durumunda tarafınıza bilgilendirme e-postası gönderilmesi,
- Kullanım ve faturalandırmaya esas üretim sayısının takibi,
- Yasal yükümlülüklerin yerine getirilmesi ve iletişim faaliyetleri.

4. Kişisel Verilerin Aktarılması
Kişisel verileriniz, hizmetin sunulabilmesi için kullanılan altyapı ve e-posta gönderim hizmeti sağlayıcıları gibi tedarikçilerle, yalnızca gerekli olduğu ölçüde ve KVKK'ya uygun olarak paylaşılabilir. Verileriniz hukuki yükümlülükler dışında üçüncü kişilerle pazarlama amacıyla paylaşılmaz.

5. Toplama Yöntemi ve Hukuki Sebep
Kişisel verileriniz, Portal üzerindeki kayıt formu aracılığıyla elektronik ortamda toplanır. Verileriniz; sözleşmenin kurulması ve ifası, meşru menfaat ve açık rızanız hukuki sebeplerine dayanılarak işlenir.

6. Haklarınız (KVKK m.11)
Kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işlenme amacını öğrenme, eksik/yanlış işlenmişse düzeltilmesini, şartları oluştuğunda silinmesini/yok edilmesini isteme ve KVKK'da sayılan diğer haklarınızı info@dijitalroket.com adresine başvurarak kullanabilirsiniz.

Bu metni onaylayarak, kişisel verilerinizin yukarıda açıklanan kapsamda işlenmesini kabul etmiş olursunuz.`;

export const TERMS_TEXT = `KULLANICI SÖZLEŞMESİ

1. Taraflar ve Konu
İşbu Kullanıcı Sözleşmesi ("Sözleşme"); Dijital Roket ("Hizmet Sağlayıcı") ile Portal'a kayıt olan firma/kullanıcı ("Kullanıcı") arasında, Portal üzerinden sunulan yapay zekâ destekli görsel üretim hizmetlerinin kullanım koşullarını düzenler.

2. Hesap ve Onay Süreci
Kullanıcı, kayıt sırasında verdiği bilgilerin doğru ve güncel olduğunu kabul eder. Kayıt sonrası hesap, Hizmet Sağlayıcı tarafından onaylanana kadar pasif durumdadır. Onay sonrası Kullanıcı, belirlediği e-posta ve şifre ile giriş yapabilir.

3. Kredi ve Kullanım
Her görsel üretimi veya düzenlemesi, hesaba tanımlanan aylık krediden düşer. Krediler her ay başında yenilenir. Kredisi biten Kullanıcı, yeni üretim için Hizmet Sağlayıcı ile iletişime geçmelidir. Üretim sayısı faturalandırmaya esas olacak şekilde kayıt altına alınır.

4. Kullanım Kuralları
Kullanıcı; hukuka, ahlaka ve üçüncü kişilerin haklarına aykırı, yanıltıcı, telif veya marka haklarını ihlal eden içerik üretmemeyi kabul eder. Üretilen görsellerin kullanımından doğan sorumluluk Kullanıcı'ya aittir.

5. Fikri Mülkiyet
Kullanıcı'nın yüklediği logo ve marka varlıkları Kullanıcı'ya aittir. Portal'ın yazılımı, arayüzü ve altyapısına ilişkin tüm haklar Hizmet Sağlayıcı'ya aittir.

6. Hizmette Değişiklik ve Askıya Alma
Hizmet Sağlayıcı, hizmet kapsamında değişiklik yapma ve kötüye kullanım halinde hesabı askıya alma hakkını saklı tutar.

7. Sorumluluğun Sınırlandırılması
Yapay zekâ ile üretilen içerikler otomatik olarak oluşturulur; Hizmet Sağlayıcı çıktıların belirli bir amaca uygunluğunu garanti etmez. Kullanıcı, üretilen içerikleri yayınlamadan önce kontrol etmekle yükümlüdür.

8. Yürürlük
Kullanıcı, kayıt sırasında bu Sözleşme'yi onaylayarak tüm hükümleri kabul etmiş sayılır.`;

export const GIZLILIK_TEXT = `GİZLİLİK POLİTİKASI

Dijital Roket olarak ziyaretçilerimizin ve müşterilerimizin gizliliğine önem veriyoruz. Bu politika, web sitemiz ve hizmetlerimiz aracılığıyla topladığımız bilgilerin nasıl kullanıldığını açıklar.

1. Toplanan Bilgiler
İletişim ve proje talep formları aracılığıyla ad-soyad, firma, telefon, e-posta ve projenize ilişkin ilettiğiniz bilgiler toplanabilir.

2. Bilgilerin Kullanımı
Toplanan bilgiler yalnızca taleplerinizi değerlendirmek, sizinle iletişime geçmek, teklif hazırlamak ve hizmetlerimizi sunmak amacıyla kullanılır. Bilgileriniz pazarlama amacıyla üçüncü kişilerle paylaşılmaz.

3. Veri Güvenliği
Bilgileriniz yetkisiz erişime karşı makul teknik ve idari tedbirlerle korunur.

4. İletişim
Gizlilik uygulamalarımıza ilişkin sorularınız için info@dijitalroket.com adresinden bize ulaşabilirsiniz.`;

export const COOKIE_TEXT = `ÇEREZ POLİTİKASI

Web sitemiz, kullanıcı deneyimini geliştirmek ve site performansını ölçmek amacıyla çerezlerden yararlanabilir.

1. Çerez Nedir?
Çerezler, ziyaret ettiğiniz web siteleri tarafından tarayıcınıza kaydedilen küçük metin dosyalarıdır.

2. Kullanılan Çerezler
- Zorunlu çerezler: Sitenin temel işlevleri için gereklidir.
- Performans/analitik çerezler: Sitenin nasıl kullanıldığını anlamamıza yardımcı olur.

3. Çerezlerin Yönetimi
Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman silebilir veya engelleyebilirsiniz. Bazı çerezlerin engellenmesi sitenin bazı bölümlerinin çalışmasını etkileyebilir.

4. İletişim
Çerez politikamızla ilgili sorularınız için info@dijitalroket.com adresinden bize ulaşabilirsiniz.`;
